// extracted by mini-css-extract-plugin
export default {"modalTitle":"modals_modalTitle__978qL","modalForm":"modals_modalForm__BoRPx","actions":"modals_actions__FOBmz"};